import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

const MyLocationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`
const LocationsDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  border-radius: 12px;
  gap: 2rem;
  padding: 2.5rem;
  background-color: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);

  @media ${queries.less.mds} {
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    gap: 0rem;
  }

  .table {
    width: 100%;
  }
`

const PageMenu = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 1rem;

  @media ${queries.less.mds} {
    align-items: center;
  }

  h2 {
    color: #767676;
    font-size: 1.5rem;
    font-weight: 600;
  }

  div {
    margin-left: auto;

    @media ${queries.less.mds} {
      width: 100%;
      margin-left: 0;
    }
  }
`
const LocationMenu = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 1rem;

  button {
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem 1rem;
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    background-color: #fff;
    color: #2d3748;
    gap: 0.625rem;

    &:focus-visible {
      outline: #a6a4a4 auto 2px;
    }

    &:focus {
      outline: #a6a4a4 auto 2px;
    }

    &.view-button[data-active='true'] {
      border: none;
      background-color: #6f64f8;
      color: #fff;
    }
  }
`

const FilterTagsDiv = styled.div`
  width: 100%;

  div {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: #484848;
    background-color: #80839014;
    border: 1px solid #80839029;
    border-radius: 8px;
    padding: 0.25rem 0.75rem;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
`

const Styles = {
  MyLocationsWrapper,
  LocationMenu,
  LocationsDiv,
  FilterTagsDiv,
  PageMenu,
}
export default Styles
